module.exports = __webpack_public_path__ + "img/P9220252.7bd683c7.jpg";